import React, {useRef, useState} from "react";
import {send_bidib_edit_cmd, send_bidib_msg} from "../../etc/cmd";
import {MdEdit, MdSave} from "react-icons/md";
import {feature, MSG_FEATURE_SET} from "../BidibMessages";

export const PropertyLine = ({uid, keyname, name, value, readonly = true}) => {
    //const {uid, keyname, name, value, readonly = true} = props;

    const [editState, setEditState] = useState(false);
    const [val, setValue] = useState(value );
    const [iconHover, setIconHover] = useState(false);
    const selectRef = useRef(null);

    function handleChange() {
        setEditState(!editState)


        if (editState) {
            setValue(val)

            let tg = {
                id: uid,
                key: keyname,
                val: val,
            }

            if( keyname.startsWith("FEATURE_") ){
                let fv =  parseInt(val) || 0
                if( fv) {
                    tg.msg = [MSG_FEATURE_SET, feature[keyname].code,]
                    send_bidib_msg(tg)
                }
            } else {
                send_bidib_edit_cmd(tg)
            }
        } else {
            selectRef?.current?.focus()
            selectRef?.current?.select()
        }
    }

    const key_style = {
        backgroundColor: 'rgb(75,84,104)',
        color: 'black',
        padding: '3px',
        fontWeight: 'bold',
    }

    const value_style = {
        backgroundColor: editState?'rgb(149,164,196)':'rgb(92,104,129)',
        color: 'black',
        outline: 'none',
        border: 'none',
        padding: '3px',
    }

    const edit_style = {
        float: 'right',
        marginTop: '2px',
        opacity: iconHover?0.9:0.3,
    }

    const icon = editState?<MdSave/>:<MdEdit/>
    const editbutton = readonly?null:<span
        style={edit_style}
        onClick={() => handleChange()}
        onMouseEnter={() => setIconHover(true)}
        onMouseLeave={() => setIconHover(false)}
    >{icon}</span>

    return (

        <div style={{
            display: 'grid',
            gridTemplateColumns: '300px auto',
            columns: 2,
            padding: 2,
            fontSize: '14px',
        }}>

            <div style={key_style}>{name}</div>
            <div style={value_style}>
                <input ref={selectRef} type={'text'} style={value_style} value={val} readOnly={!editState} onChange={(e) => setValue(e.target.value)}/>
                {editbutton}
            </div>

        </div>
    )
}

